// extracted by mini-css-extract-plugin
module.exports = {"type":"BackupRow-type-3zo1o TableRowCell-cell-2fbg4","actions":"BackupRow-actions-3PDld TableRowCell-cell-2fbg4"};